module.exports = __webpack_public_path__ + "static/media/Rrose_Do_Shit.9daed95e.png";